
export const TOKEN_STORAGE_KEY = 'token';
export const PASSWORD_REGEX = new RegExp('^(?=(?:.*[A-Z]){1})(?=(?:.*[a-z]){1})(?=(?:.*\\d){1})(?=(?:.*[!@#$%^&*]){1}).{10,}$');
